export default __webpack_public_path__ + "static/media/strategik4.0bb8a2c9.jpg";